const iframe = document.getElementById("myframe");
const loading = document.getElementById("loading");

iframe.addEventListener("load", function () {
  console.log('ready');
  const header = document.querySelector(".header-wrapper");
  const footer = document.querySelector(".site-footer");
  if (header) {
    header.style.display = "none";
  }

  if (footer) {
    footer.style.display = "none";
  }

  if (window.TitleBar) {
    iframe.contentWindow.postMessage({ inApp: true }, "*");
  } else {
    iframe.contentWindow.postMessage({ inApp: false }, "*");
  }
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("userEmail")) {
    iframe.contentWindow.postMessage(
      { userEmail: urlParams.get("userEmail") },
      "*"
    );
  }
});

window.addEventListener("message", function (event) {
  const receivedMessage = event.data;
  console.log(event.data)
  if (event.data.openUrl) {
    console.log(event.data)
    window?.openUrl?.postMessage(event.data.openUrl);
  }
  if (event.data.titleBar && window.TitleBar) {
    window.TitleBar.postMessage(JSON.stringify({ title: event.data.titleBar }));
  }
  if(event.data.titleBar){
     document.title = event.data.titleBar
  }
 
});
